import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaXmark } from "react-icons/fa6";
import "./Navbar.css";

import Logo from "../Assets/logos/ample-house-logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="ample-navbar-wrapper">
      <nav className="ample-navbar-main">
        
        {/* LOGO */}
        <NavLink
          to="/"
          className="ample-navbar-logo"
          onClick={() => setMenuOpen(false)}
        >
          <img src={Logo} alt="Journey Man Logo" />
        </NavLink>

        {/* NAV LINKS */}
        <div className={`ample-navbar-links ${menuOpen ? "ample-navbar-open" : ""}`}>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>
            Home
          </NavLink>

          <NavLink to="/about-us" onClick={() => setMenuOpen(false)}>
            About Us
          </NavLink>

          <NavLink to="/ample-productions" onClick={() => setMenuOpen(false)}>
            Ample Productions
          </NavLink>

          <NavLink to="ample-event/" onClick={() => setMenuOpen(false)}>
            Ample Events
          </NavLink>

          <NavLink to="/ample-publications" onClick={() => setMenuOpen(false)}>
            Ample Publications
          </NavLink>

          <NavLink to="/ample-academy" onClick={() => setMenuOpen(false)}>
            Ample Academy
          </NavLink>

          {/* CTA BUTTON */}
          <NavLink
            to="/contact-us"
            className="ample-navbar-btn"
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </NavLink>
        </div>

        {/* MOBILE TOGGLE */}
        <button
          className="ample-navbar-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FaXmark /> : <FaBars />}
        </button>
      </nav>
    </header>
  );
};

export default Navbar;